<div class="SCR-knwtst-pop-area">
    <button class="pop-cls-btn" mat-dialog-close>
        <img src="assets/img/filter-close-icon.png" class="cls-icn" />
    </button>
    <h3 class="SCR-knwtst-popup-hdng">Know your test</h3>

    <ol class="SCR-knwtst-list">
        <li>The test will have <b>120 questions</b> to be completed in <b>90 minutes</b>.</li>
        <li>The test includes <b>MCQs and numerical questions</b>.</li>
        <li>For every correct answer, you will be awarded <b>four marks</b> and for every incorrect answer, <b>one mark</b> will be deducted.</li>
        <li><b>No marks</b> will be awarded or deducted for unattempted questions</li>
    </ol>
</div>